import { ContactDetails, OrganisationDetails } from 'model/hams/contact';

const organisationTypes = {
  CUSTOMER: 'CUSTOMER',
  EXPERT: 'EXPERT',
  RESELLER: 'RESELLER',
  CORPORATE_RESELLER: 'CORPORATE_RESELLER',
};
export const { CUSTOMER, EXPERT, RESELLER, CORPORATE_RESELLER } = organisationTypes;
export type OrganisationType = $Values<typeof organisationTypes> | null;
export type ExtendedOrganisationDetails = OrganisationDetails & {
  organisationType: OrganisationType;
  payOnAccount: boolean;
  name: string;
};
export type CurrentContact = {
  contactDetails: ContactDetails;
  organisationDetails: ExtendedOrganisationDetails;
};
